"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('upload-two', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(3.000000, 7.000000)",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("g", {
    transform: "translate(20.627149, 24.921053) scale(1, -1) translate(-20.627149, -24.921053) translate(19.627149, 15.421053)"
  }, _react.default.createElement("path", {
    d: "M1.38118472,0.421052632 L1.37285138,18.4210526"
  })), _react.default.createElement("path", {
    d: "M37.517692,27.3161117 C40.8042581,25.0049985 42.2135166,20.8301617 41,17 C39.7864834,13.1698383 36.0704359,11.0713692 32.0526316,11.074512 L29.7315789,11.074512 C28.2142636,5.16125036 23.2081058,0.795724382 17.1433735,0.0972036243 C11.0786412,-0.601317134 5.21111138,2.51180459 2.38920996,7.92528602 C-0.432691467,13.3387675 0.375344683,19.9316811 4.42105263,24.5034593"
  }))), _react.default.createElement("polyline", {
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(24.000000, 27.636039) rotate(135.000000) translate(-24.000000, -27.636039) ",
    points: "19.5 23.136039 19.5 32.136039 28.5 32.136039"
  })));
});

exports.default = _default;